import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lifeCycle",
  "use": "icon-lifeCycle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lifeCycle\"><path d=\"M956.61 480.35l-63.54 4.52A382.09 382.09 0 0 1 131.87 551h171.61l91.94-142.58L464.14 716l147-214.41 50.6 49.41H795v-69.17H689.84l-89.34-87L497 545.86l-70.13-313.79L265.8 481.83H131.17a386.36 386.36 0 0 1 11.94-68.73A381.8 381.8 0 0 1 846 326.77l55.7-30.9c-0.06-0.12-0.13-0.23-0.19-0.34V115h-69.13v87.18a444.93 444.93 0 1 0 124.23 278.17z\" p-id=\"2679\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-lifeCycle.svg
// module id = obve
// module chunks = 175